/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagLeftIcon20Light = forwardRef('ArrowDim1DiagLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.5 2a.5.5 0 0 1 0 1H3.707L17 16.293V11.5a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5h-5a.5.5 0 0 1 0-1h4.793L3 3.707V8.5a.5.5 0 0 1-1 0v-5A1.5 1.5 0 0 1 3.5 2h5Z" })));
});
